import { userConstants } from '../../constants';

const initialUsersState = {
  items: []
};

export function users(state = initialUsersState, action: any) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case userConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.payload
      };
    case userConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    case userConstants.GET_BY_ID_REQUEST:
      return {
        items: action.users
      };
    case userConstants.CREATE_REQUEST:
      return {
        ...state,
        creating: true
      };
    case userConstants.CREATE_SUCCESS:
      return {
        ...state,
        items: [...state.items, action.user],
        creating: false
      };
    case userConstants.CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.error
      };
    case userConstants.UPDATE_REQUEST:
      return {
        ...state,
        items: state.items.map((user: any) =>
          user.id === action.user.id ? { ...user, updating: true } : user
        )
      };
    case userConstants.UPDATE_SUCCESS:
      return {
        ...state,
        items: state.items.map((user: any) =>
          user.id === action.user.id ? action.user : user
        )
      };
    case userConstants.UPDATE_FAILURE:
      return {
        ...state,
        items: state.items.map((user: any) => {
          if (user.id === action.user.id) {
            const { updating, ...userCopy } = user;
            return { ...userCopy, updateError: action.error };
          }
          return user;
        })
      };
    case userConstants.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map((user: any) =>
          user.id === action.id ? { ...user, deleting: true } : user
        )
      };
    case userConstants.DELETE_SUCCESS:
      return {
        items: state.items.filter((user: any) => user.id !== action.id)
      };
    case userConstants.DELETE_FAILURE:
      return {
        ...state,
        items: state.items.map((user: any) => {
          if (user.id === action.id) {
            const { deleting, ...userCopy } = user;
            return { ...userCopy, deleteError: action.error };
          }
          return user;
        })
      };
    default:
      return state;
  }
}
